<template>
  <template-order-list-page></template-order-list-page>
</template>

<script lang="ts">

import templateOrderListPage from '@/app-template/lib/pages/OrderListPage.vue';

export default {
  name: "OrderListPage",
  components: { templateOrderListPage },
};
</script>